import axios, { AxiosError } from 'axios';
import { Api } from '../axiosApi';

interface DataRNfe {
  serie: number;
  nfe: number;
  dhemi: string;
  nome: string;
  cpf: string;
  cfop: string;
  vnfe: number;
  finalidade: string;
  status: string;
}


interface ErrorResponse {
  errors: {
    default: string;
  };
}
const RNfe = async (
  tipo: string,
  datainicial: string,
  datafinal: string,
  status: string
): Promise<DataRNfe[] | Error> => {

  try {

    const urlRelativa =
      `/relatorionfe?tipo=${tipo}&datainicial=${datainicial}&datafinal=${datafinal},&status=${status}`;

    const { data } = await Api.get<DataRNfe[]>(urlRelativa);

    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o relatório de vendas.');

  } catch (error) {

    if (axios.isAxiosError(error)) {

      const axiosError = error as AxiosError<ErrorResponse>;

      if (axiosError.response) {

        const errorMessage =
          axiosError.response.data.errors?.default || 'Erro desconhecido';

        return new Error(errorMessage);

      } else if (axiosError.request) {

        return new Error('Nenhuma resposta do servidor');

      } else {

        return new Error(axiosError.message);

      }

    }

    return new Error('Erro inesperado');
  }
};

const RNfCe = async (
  tipo: string,
  datainicial: string,
  datafinal: string,
  status: string

): Promise<DataRNfe[] | Error> => {

  try {

    const urlRelativa =
      `/relatorionfce?tipo=${tipo}&datainicial=${datainicial}&datafinal=${datafinal}&status=${status}`;

    const { data } = await Api.get<DataRNfe[]>(urlRelativa);

    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o relatório de vendas.');

  } catch (error) {

    if (axios.isAxiosError(error)) {

      const axiosError = error as AxiosError<ErrorResponse>;

      if (axiosError.response) {

        const errorMessage =
          axiosError.response.data.errors?.default || 'Erro desconhecido';

        return new Error(errorMessage);

      } else if (axiosError.request) {

        return new Error('Nenhuma resposta do servidor');

      } else {

        return new Error(axiosError.message);

      }

    }

    return new Error('Erro inesperado');
  }
};


export const RelatorioFiscalService = {
  RNfe,
  RNfCe
};